<script>
export default {
    name: "SpacerElement",
    mixins: [],
    data () {
        return {
            elementType: 'spacer'
        }
    },
    computed: {
        getDefaultDataStructure () {
            return {
                elementType: this.elementType,
                elementId: this.elementId,
                styles: null,
                linkData: {},
                responsiveAlignmentClass: {
                    'desktop': '',
                    'tablet-portrait': '',
                    'tablet-landscape': '',
                    'smartphone-portrait': '',
                    'smartphone-landscape': ''
                },
            }
        },
    }
}
</script>